<template>
	<v-app id="inspire">
		<!-- 左侧菜单 -->
		<v-navigation-drawer v-if="renewalReady && !renewalBlocked" app clipped floating dark v-model="drawer" width="240px">
			<v-list dense class="dark">
				<template v-for="item in filter(global.routeTree)">
					<!-- 没有子项目时显示一个菜单 -->
					<v-list-item v-if="!item.children" class="ml-3" @click="$router.push(item.routePath)">
						<v-list-item-icon>
							<v-icon :color="item.routePath===$route.path?'#2196f3':''">{{item.icon}}</v-icon>
						</v-list-item-icon>
						<v-list-item-title :style="{color: item.routePath===$route.path?'#2196f3':''}">
							{{item.functionName}}</v-list-item-title>
					</v-list-item>
					<!-- 有子项目时显示菜单组 -->
					<v-list-group v-else :prepend-icon="item.icon?item.icon:''" class="pl-3" no-action
						:value="item.open">
						<template v-slot:activator>
							<v-list-item-title v-html="item.functionName" />
						</template>
						<v-list-item v-for="(admin, i) in item.children" :key="i" link dense class="pl-9"
							@click="openPage(admin.routePath)">
							<v-list-item-icon v-if="admin.icon" class="mr-3">
								<v-icon v-text="admin.icon" :color="admin.routePath===$route.path?'blue':''"></v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title v-html="admin.functionName"
									:style="{color: admin.routePath===$route.path?'#2196f3':''}"></v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>
				</template>
			</v-list>
		</v-navigation-drawer>
		<!-- 登录用户信息 -->
		<v-navigation-drawer app right temporary v-model="system">
			<v-list-item>
				<v-list-item-avatar>
					<v-avatar color="orange" size="32">
						<v-img v-if="global.employee.avatar" :src="global.config.imgPre+global.employee.avatar"></v-img>
					</v-avatar>
				</v-list-item-avatar>
				<v-list-item-content>
					<v-list-item-title>{{ global.employee.nickName +'(' + global.employee.trueName + ')' }}
					</v-list-item-title>
					<v-list-item-subtitle>ID:{{ global.employee.employeeNo}}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
			<v-divider />
			<v-list dense>
				<v-list-item @click="system = !system">
					<v-list-item-action>
						<v-icon>mdi-close</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>关闭面板</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item @click="changePwd.dialog=true">
					<v-list-item-action>
						<v-icon>mdi-shield-key</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>修改密码</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item @click="logout">
					<v-list-item-action>
						<v-icon>mdi-exit-to-app</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>退出登录</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
		<!-- 顶部 -->
		<v-app-bar app clipped-left>
			<v-app-bar-nav-icon @click.stop="drawer = !drawer" />
			<v-toolbar-title>有课丫机构管理平台</v-toolbar-title>
			<v-card color="info" class="ml-3 pa-2" style="position: relative;">
				
				<div class="d-flex align-center" v-if="currentShop" style="cursor: pointer; width: 210px;" @click="toChangeShop">
					<v-avatar size="30">
						<v-img v-if="currentShop.shopLogo" :src="global.config.imgPre+currentShop.shopLogo" width="30px"
							height="30px"></v-img>
					</v-avatar>
					<!--  -->
					<div class="ml-2 mr-2">
						<div style="color:white; font-size:13px" >{{ currentShop.shopName}}</div>
						<div style="color:white; font-size: 12px;">有效期:{{ currentShop.expireDate }}</div>
					</div>
					
					<v-spacer></v-spacer>
					<v-icon v-if="!changeShop.showList">mdi-menu-right</v-icon>
					<v-icon v-if="changeShop.showList">mdi-menu-left</v-icon>
				</div>
				
				
				<div v-if="changeShop.showList" style="position: absolute;top:0;left:215px; ">
					<v-list nav dense width="210px" color="info" style="border-radius: 5px;">
						<v-list-item-group v-model="changeShop.index" active-class="active_item">
							<v-list-item v-for="(item,index) in changeShop.shopList" :key="index" @click="setCurrentShop(item)">
								<div class="d-flex align-center">
									<v-avatar size="30">
										<v-img v-if="item.shopLogo" :src="global.config.imgPre+item.shopLogo" width="30px"
											height="30px"></v-img>
									</v-avatar>
									<span style=" font-size:13px" class=" ml-2 mr-2">{{ item.shopName}}</span>
								</div>
								
							</v-list-item>
						</v-list-item-group>
					</v-list>
				</div>
			</v-card>

			<v-spacer></v-spacer>
			<v-btn v-if="renewalEntryVisible" color="primary" class="mr-3" @click="$refs.renewal.open()">校区续费</v-btn>

			<v-btn @click.stop="system = !system" icon>
				<v-icon>mdi-apps</v-icon>
			</v-btn>
		</v-app-bar>
		<!-- 主内容区 -->
		<v-main>
			<div style="padding:8px">
				<v-alert v-if="accountModes.error" type="warning" dense>{{accountModes.error}} <v-btn text small @click="refreshModes">重试校区配置</v-btn></v-alert>
				<CampusRenewal ref="renewal" :shop-id="currentShop ? currentShop.id : ''" :employee-id="global.employee.id" @access="onRenewalAccess" @logout="logout" />
				<router-view v-if="renewalReady && !renewalBlocked"></router-view>
			</div>
		</v-main>
		<!-- 页脚 -->
		<v-footer app>
			<div :span="24" class="bt-footer">
				<span>Copyright © 2022 长沙永芸信息科技有限公司 All Rights Reserved.</span>
				<span class="ml-4">ICP备案号：湘ICP备2022020124号-1</span>
			</div>
		</v-footer>

		<!-- 修改密码 dialog -->
		<v-dialog title="修改密码" v-model="changePwd.dialog" max-width="400" persistent>
			<v-card>
				<v-card-title>修改登录密码</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="12">
							<v-text-field label="新密码" type="password" v-model="changePwd.newPwd" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="确认密码" type="password" v-model="changePwd.newPwd2" dense outlined>
							</v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="changePwd.dialog=false">取消</v-btn>
					<v-btn @click="submitChangePwd" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		

	</v-app>
</template>

<script>
	import {accountModes,refreshAccountModes,filterAccountMenus} from '../config/accountModes'
	import CampusRenewal from "../components/CampusRenewal.vue"
	import global from "../config/global"
	import store from "../config/storage"
	import md5 from "js-md5"
	import {EventBus} from '../config/eventBus'
	export default {
		name: 'layout',
		components: { CampusRenewal },
		data() {
			return {
				accountModes,
				drawer: null,
				system: false,
				global: global,
				store: store,
				search: "",
				changePwd: {
					dialog: false,
					newPwd: "",
					newPwd2: ""
				},
				changeShop: {
					shopList:[],
					showList: false,
					index:0
				},
				currentShop:null,
				renewalReady: false,
				renewalBlocked: true,
				renewalEntryVisible: false
				

			}
		},
		created() {
			this.currentShop = this.store.getCurrentShop();
			EventBus.$on("updateShop", this.updateCurrentShop);
 EventBus.$on("accountModesUpdated", this.refreshModes);
 this.refreshModes();
		},
		beforeDestroy() { EventBus.$off("updateShop", this.updateCurrentShop); EventBus.$off("accountModesUpdated", this.refreshModes); },

		methods: {
			onRenewalAccess(state) {
				this.renewalReady = state.ready;
				this.renewalBlocked = state.blocked;
				// Show renewal in the final 30 days, including expired campuses.
				this.renewalEntryVisible = !!(state.ready && state.current && Number.isFinite(state.current.daysRemaining) && state.current.daysRemaining < 30);
				if (state.ready && state.current && this.currentShop && String(state.current.id) === String(this.currentShop.id)) {
					this.currentShop = { ...this.currentShop, expireDate: state.current.expireDate, status: state.current.status };
					this.store.setCurrentShop(this.currentShop);
				}
			},
			updateCurrentShop() { this.currentShop = this.store.getCurrentShop(); this.refreshModes(); },
 refreshModes() { return refreshAccountModes(this.axios, this.currentShop&&this.currentShop.id); },
			logout() {

				// 调用登出API
				const that = this;
				this.axios.post("/sys/employee/logout", {}).catch(function(e) {

				}).then(function(res) {
					console.log(res);
					if (res && res.data) {
						console.log("logout api res:", res.data);
						if (res.data["code"] === 200) {

							//store.remove(store.config.token);
							store.clear();
							that.$router.push("/login");

						} else {
							that.$noty.error("登录失败:" + res.data["message"]);
						}
					}
				});
			},
			filter(list) {
				// 没有搜索时 处理是否打开文件夹
				if (!this.search) {
					for (let i = 0; i < list.length; i++) {
						list[i].open = this.$route.path.indexOf(list[i].routePath) === 0
					}
					return filterAccountMenus(list.filter(v => v.functionId !== ''),this.accountModes.ready?this.accountModes.modes:[])
				}
			},
			toChangeShop(){
				
				if(this.changeShop.showList){
					this.changeShop.showList = false;
					return
				}
				
				this.changeShop.shopList = (this.global.employee.shopList || []).length ? this.global.employee.shopList : (this.global.employee.renewalShopList || []);
				this.changeShop.showList = true;
				
				let selectedIndex = 0 ;
				this.changeShop.shopList.forEach((item,index)=>{
					if (this.currentShop && item.id == this.currentShop.id){
						selectedIndex = index;
					}
				})
				this.changeShop.index = selectedIndex;
				
			},
			setCurrentShop(item){
				// 切换校区
				if (!this.currentShop || item.id !== this.currentShop.id){
					this.store.setCurrentShop(item);
					// 切换校区 刷新页面
					if (location.href.indexOf("#reloaded") == -1) {
					  location.href = location.href + "#reloaded";
					  location.reload();
					}
				}
				// 没改变 就关闭列表
				this.changeShop.showList = false;

			},
			openPage(path) {
				// console.log("open path:" + path);
				this.$router.push(path);
			},
			submitChangePwd() {
				if (!this.changePwd.newPwd) {
					this.$noty.error("请输入新密码");
					return
				}


				if (!this.changePwd.newPwd2) {
					this.$noty.error("请输入确认新密码");
					return
				}
				if (this.changePwd.newPwd !== this.changePwd.newPwd2) {
					this.$noty.error("两次密码不一致");
					return
				}

				// 调用登出API
				const that = this;
				let newPassword = md5(this.changePwd.newPwd);
				this.axios.post("/sys/employee/password/change", {
					password: newPassword
				}).catch(function(e) {

				}).then(function(res) {
					console.log(res);
					if (res && res.data) {

						if (res.data["code"] === 200) {

							that.changePwd.dialog = false;
							that.$noty.success("修改成功,下次直接使用新密码登录");
							return


						} else {
							that.$noty.error("登录失败:" + res.data["message"]);
						}
					} else {
						that.$noty.error("网络异常");
						return
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped="">
	.active_item {
		background-color:#ffffff;
	}
</style>
